import { render, staticRenderFns } from "./HistoryDatasetDisplay.vue?vue&type=template&id=c4342bf0&scoped=true&"
import script from "./HistoryDatasetDisplay.vue?vue&type=script&lang=js&"
export * from "./HistoryDatasetDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDatasetDisplay.vue?vue&type=style&index=0&id=c4342bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4342bf0",
  null
  
)

export default component.exports